import {
  getWalletItemsSectioned,
  GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE,
  WalletItemsSectionedQueryResponse,
} from '@leagueplatform/wallet-api';
import { UseQueryOptions, useQuery } from 'react-query';
import { useGetHighmarkUserProfile } from 'hooks/use-get-user-profile';

export function useWalletItemsSectionedQuery(options?: UseQueryOptions<any>) {
  const { data: userProfile } = useGetHighmarkUserProfile();
  const userId = userProfile?.userId;

  return useQuery<WalletItemsSectionedQueryResponse>(
    [GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE, userId],
    () => getWalletItemsSectioned(userId),
    options,
  );
}
